import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
  card: {
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    boxShadow: 'none',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(3),
    flexGrow: 1,
    '&:last-child': {
      paddingBottom: theme.spacing(3),
    },
  },
  officeName: {
    fontWeight: 700,
    fontSize: '18px',
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(0.5),
  },
  ids: {
    color: '#757575',
    fontSize: '14px',
    marginBottom: theme.spacing(2),
  },
  addressBlock: {
    flexGrow: 1,
    marginBottom: theme.spacing(2),
  },
  selectButton: {
    borderColor: theme.palette.secondary.main,
    color: theme.palette.secondary.main,
    textTransform: 'none',
    borderRadius: '16px',
    alignSelf: 'flex-start',
    '&:hover': {
      borderColor: theme.palette.action.active,
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.secondary.contrastText,
    },
  },
}))

export default useStyles
